<template>
    <div id="buyingTask" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>买货任务</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="创建日期" prop="dateRange" label-width="100px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="购买平台" prop="platform" label-width="100px">
                    <el-select v-model="queryParams.platform" clearable placeholder="购买平台" size="small">
                        <el-option v-for="item in shopPlatform" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="店铺名称" prop="shopname" label-width="100px">
                    <el-input v-model="queryParams.shopname" clearable placeholder="店铺名称" size="small" />
                </el-form-item>

                <el-form-item label="购买产品" prop="productname" label-width="100px">
                    <el-input v-model="queryParams.productname" clearable placeholder="购买产品" size="small" />
                </el-form-item>

                <el-form-item label="购买方式" prop="buytype" label-width="100px">
                    <el-select v-model="buytype" clearable placeholder="购买方式" size="small" multiple>
                        <el-option v-for="item in shopAway" :key="item.value" :label="item.lable" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                    <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
                </el-form-item>
            </el-form>
        </section>
        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">任务</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="changeHistory">变更历史</el-button>
                </el-col>
            </el-row>

            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun">
                <el-table-column label="任务ID" align="left" key="taskid" prop="taskid" />
                <el-table-column label="品牌" align="left" key="brandname" prop="brandname" />
                <el-table-column label="购买平台" align="left" key="platform" prop="platform" />
                <el-table-column label="店铺名称" align="left" key="shopname" prop="shopname" />
                <el-table-column label="购买链接" align="left">
                    <template slot-scope="scope">
                        <div style="width: 300px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ scope.row.productlink }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="购买产品" align="left">
                    <template slot-scope="scope">
                        <div style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                            {{ scope.row.productname }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="任务数量" align="left" key="tasknum" prop="tasknum" />
                <el-table-column label="任务剩余购买数量" align="left" key="tasknumsurplus" prop="tasknumsurplus" />
                <el-table-column label="购买方式" align="left" key="buytype" prop="buytype" />
                <el-table-column label="创建时间" align="left" sortable>
                    <template slot-scope="scope">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
                <el-table-column label="操作" align="left" class-name="small-padding fixed-width">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" icon="el-icon-edit" :disabled="scope.row.tasknumsurplus == 0"
                            @click="handleUpdate(scope.row.taskid)">买货</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10,20,50,100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>
        <!-- 添加或修改用户配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="height: 500px;overflow: auto;">
                <el-row>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="任务ID">
                            {{ form.taskid }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="品牌">
                            {{ form.brandname }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买平台" prop="platform">
                            <el-select v-model="form.platform" clearable placeholder="购买平台" style="width: 410px"
                                size="small">
                                <el-option v-for="item in shopPlatform" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="店铺名称" prop="shopname">
                            <el-input v-model="form.shopname" clearable placeholder="店铺名称" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买链接" prop="productlink">
                            <el-input v-model="form.productlink" clearable placeholder="购买链接" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label=" 购买产品" prop="productname">
                            <el-input v-model="form.productname" clearable placeholder=" 购买产品" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="任务数量" prop="tasknum">
                            <el-input v-model="form.tasknum" clearable placeholder="任务数量" type="number"
                                style="width: 210px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="剩余购买数量">
                            {{ form.tasknumsurplus }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="购买方式" prop="buytype">
                            <el-select v-model="form.buytype" clearable placeholder="购买方式" style="width: 410px"
                                size="small" :disabled="disabled">
                                <el-option v-for="item in shopAway" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注1">
                            <el-input v-model="form.remark1" clearable placeholder="备注1" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注2">
                            <el-input v-model="form.remark2" clearable placeholder="备注2" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注3">
                            <el-input v-model="form.remark3" clearable placeholder="备注3" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '任务详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
export default {
    name: "buyingTask",
    components: {},
    data() {
        return {
            buytype: [],
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                platform: null,
                shopname: null,
                productname: null,
                buytype: null,
            },
            title: '',
            totalNum: 0,
            currentPage: 0,
            dateRange: [],
            loading: false,
            tableData: [],
            showSearch: true,
            shopPlatform: [{
                label: '淘宝',
                value: '淘宝'
            }, {
                label: '天猫',
                value: '天猫'
            }, {
                label: '京东',
                value: '京东'
            }, {
                label: '拼多多',
                value: '拼多多'
            }, {
                label: '抖音',
                value: '抖音'
            }, {
                label: '闲鱼',
                value: '闲鱼'
            }, {
                label: '快手',
                value: '快手'
            }, {
                label: '唯品会',
                value: '唯品会'
            }, {
                label: '微信小程序',
                value: '微信小程序'
            }],
            shopData: [],
            shopAway: [{
                label: 'R',
                value: 'R买'
            }, {
                label: '购买',
                value: '购买'
            }, {
                label: '溯源',
                value: '溯源'
            }],
            // 表单参数
            form: {},
            rules: {
                platform: [
                    { required: true, message: '请选择购买平台', trigger: 'blur' },
                ],
                shopname: [
                    { required: true, message: '请填写店铺名称', trigger: 'blur' },
                ],
                productlink: [
                    { required: true, message: '请填写购买链接', trigger: 'blur' },
                ],
                productname: [
                    { required: true, message: '请填写购买产品', trigger: 'blur' },
                ],
                tasknum: [
                    { required: true, message: '请填写购买数量', trigger: 'blur' },
                ],
                buytype: [
                    { required: true, message: '请选择购买方式', trigger: 'blur' },
                ]
            },
            open: false,
            disabled: false
        };
    },
    components: {
        pagination
    },
    created() {
        this.getList();
        const userData = localStorage.getItem('userData');
    },
    methods: {
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        // 变更历史
        changeHistory() {
            this.$router.push({
                path: '/salesRegistration/buyingHistory',
                query: { modulename: 'RW', name: '买货任务', url: '/salesRegistration/buyingTask/index' }
            })
        },
        handleUpdate(taskid) {
            this.$router.push({
                path: '/salesRegistration/buyingManagement/index',
                query: { taskid: taskid }
            })
        },
        taskidFun(data) {
            if (data.status == 1) {
                this.disabled = true
            } else {
                this.disabled = false
            }
            let params = {
                id: data.id
            }
            fetch({
                url: "hcm/hcmOrderTask/getOrderTaskDetails",
                method: "get",
                params: params,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.form = {};
                    this.form = result.data.details;
                    this.title = '任务详情'
                    this.open = true;
                    this.$refs['form'].resetFields();
                }
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            if (this.buytype.length > 0) {
                this.queryParams.buytype = this.buytype.join(',')
            }
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmOrderTask/getList",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        transChange() {

        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmOrderTask/hcmOrderTaskDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '买货任务.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 新增
        handleAdd() {
            this.title = "任务录入";
            this.open = true;
            this.disabled = false;
            this.$refs['form'].resetFields();
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    fetch({
                        url: "hcm/hcmOrderTask/saveOrderTask",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                            this.getList();
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style lang="scss">
#buyingTask {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>